module.exports = __webpack_public_path__ + "img/success.b2407d0.png";